// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__yz0Jk","skeleton":"style_skeleton__3rqSM","message":"style_message__2wrbG","smallSkeleton":"style_smallSkeleton__rVGDn"};